<mat-dialog-content class="flex flex-col">
    <div class="flex flex-col">
        <mat-form-field class="m-3">
            <mat-label>{{'select_city'|translate}}</mat-label>
            <mat-select [formControl]="cityControl" [placeholder]="translate.getTranslation('city')" [compareWith]="compareFn">
                <mat-option>
                    <ngx-mat-select-search [formControl]="filterCtrl" placeholderLabel="Search cities..." noEntriesFoundLabel="No matching cities found"> </ngx-mat-select-search>
                </mat-option>
                <mat-option value="">
                  {{translate.localize(originalCountry.name)}}
                </mat-option>
                <mat-optgroup *ngFor="let area of filteredAreas|async" [label]="translate.localize(area.name)" [hidden]="!!area.disabled" [disabled]="!!area.disabled">
                    <mat-option *ngFor="let city of area.cities" [value]="{cityId: city._id, areaId: area._id}" [hidden]="!!city.disabled" [disabled]="!!city.disabled">
                        {{translate.localize(city.name)}}
                    </mat-option>
                </mat-optgroup>
            </mat-select>
        </mat-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close type="button">CANCEL</button>
    <button color="primary" mat-raised-button (click)="setLocation()">{{'done'|translate}}</button>
</mat-dialog-actions>
